import { Button } from '@material-ui/core';
import * as React from 'react';

const white = '#ffffff';

import { unexpectedEmailAddress } from '../common/communication-utils';
import { Communication } from '../state';

interface CommunicationWarningUnknownEmailProps {
    data: Communication;
    addContactFromMessage: (payload: {
        account: string;
        personId: string;
        value: string;
        messageId: string;
        threadId: string;
    }) => void;
    ignoreContactFromMessage: (account: string, messageId: string, threadId: string) => void;
}

export const CommunicationWarningUnknownEmail: React.FunctionComponent<CommunicationWarningUnknownEmailProps> = ({
    addContactFromMessage,
    ignoreContactFromMessage,
    data
}) => {
    const { account, messageId, threadId } = data;

    const handleAutoAddEmail = () => {
        const { unknownEmailFound, personIds } = data;
        const personId = personIds[0];
        addContactFromMessage({ account, personId, messageId, value: unknownEmailFound, threadId });
    };

    const handleIgnoreContactFromMessage = () => {
        ignoreContactFromMessage(account, messageId, threadId);
    };

    const hasUnexpectedEmail = unexpectedEmailAddress(data);
    const addUnexpectedEmailButton =
        hasUnexpectedEmail && data.personIds && data.personIds.length === 1 ? (
            <Button onClick={handleAutoAddEmail} key="add-email" variant="text" style={{ color: white }}>
                Add Email
            </Button>
        ) : null;
    const ignoreUnexpectedEmailButton =
        hasUnexpectedEmail && data.personIds && data.personIds.length === 1 ? (
            <Button onClick={handleIgnoreContactFromMessage} key="ignore-email" variant="text" style={{ color: white }}>
                Ignore New Email Address
            </Button>
        ) : null;

    const unexpectedEmailWarning = hasUnexpectedEmail ? (
        <div className="email-header-warning unexpected-email">
            <div>The email address {data.unknownEmailFound} is not yet associated with this candidate.</div>
            <div>
                {addUnexpectedEmailButton}
                {ignoreUnexpectedEmailButton}
            </div>
        </div>
    ) : null;

    return unexpectedEmailWarning;
};
